import React, { useState } from "react";
import { max } from "../../utils";

const Event = ({ image, title, about }) => {
	const [height, setHeight] = useState(200);
	const onImgLoad = ({ target: img }) => {
		const { offsetHeight, offsetWidth } = img;
		setHeight(() => 2 * max(offsetHeight, offsetWidth));
	};
	return (
		<div
			className="event"
			style={{
				backgroundImage: `url(${image})`,
				height: `${height}px`,
			}}
		>
			<img
				src={image}
				className="event-image"
				alt="not"
				onLoad={onImgLoad}
			/>
			<div className="event-title"></div>
			<div className="event-content">
				<h2>
					<span>{title}</span>
				</h2>
				<p>{about}</p>
			</div>
			<span className="event-frame event-frame-1"></span>
			<span className="event-frame event-frame-2"></span>
			<span className="event-frame event-frame-3"></span>
			<span className="event-frame event-frame-4"></span>
		</div>
	);
};

export default Event;
